import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "./SocialLinks.css"; // import the CSS

const SocialLinks = () => {
  return (
    <section className="sp-contact-social-section">
      <h2>Connect With Us</h2>
      <div className="sp-contact-social-icons">
        <a
          href="https://www.facebook.com/share/1ZEARUmfKZ/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon facebook"
        >
          <FaFacebookF size={32} />
        </a>
        <a
          href="https://www.instagram.com/satimatechnovasolutions/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon instagram"
        >
          <FaInstagram size={32} />
        </a>
        <a
          href="https://www.linkedin.com/company/107933110/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon linkedin"
        >
          <FaLinkedinIn size={32} />
        </a>
      </div>
    </section>
  );
};

export default SocialLinks;
